const RoomCreate = () =>
	import(/* webpackChunkName: "roomcreate"*/ "@/views/Room/Create.vue");

const RoomEdit = () =>
	import(/* webpackChunkName: "roomedit"*/ "@/views/Room/Edit.vue");

export default [
	{
		path: "listings/facility/:id/room/create",
		name: "RoomCreate",
		component: RoomCreate,
		meta: {
			title: "DailyAdmin - Room create"
		}
	},
	{
		path: "listings/facility/:id/room/:roomid/edit/",
		name: "RoomEdit",
		component: RoomEdit,
		meta: {
			title: "DailyAdmin - Room edit"
		}
	}
];
